import { gql } from '@common/hooks';

export const AssignmentSelectFragment = gql`
  fragment AssignmentSelectFragment on StaffingRequestAssignment {
    id
    startDate
    endDate
    worksProfile {
      id
      firstName
      lastName
    }
    staffingRequest {
      id
      code
      name
    }
    organizationProfile {
      id
      employeeId
    }
  }
`;

export type AssignmentSelectFragmentType = {
  id: string;
  startDate: string;
  endDate: string;
  organizationProfile: {
    id: string;
    employeeId: string;
  };
  staffingRequest: {
    code: string;
    id: string;
    name: string;
  };
  worksProfile: {
    id: string;
    firstName: string;
    lastName: string;
  };
};
